import { Empty } from 'antd';
import { InboxOutlined } from '@ant-design/icons';

interface EmptyStateProps {
  message?: string;
}

export function EmptyState({ message = 'Nenhum dado encontrado para o período selecionado' }: EmptyStateProps) {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '250px',
      padding: '40px 20px'
    }}>
      <Empty
        image={<InboxOutlined style={{ fontSize: 64, color: '#d9d9d9' }} />}
        description={
          <span style={{ color: '#595959' }}>
            {message}
          </span>
        }
      />
    </div>
  );
}
